import Vue from 'vue'
import Router from 'vue-router';
import Home from './views/Home.vue';
import Signup from './views/Signup.vue';
import Login from './views/Login.vue';
import VerifyAccount from './views/Verify.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import SetPassword from './views/SetPassword.vue';
import PageNotFound from './views/PageNotFound.vue';
import AppIndex from "@/components/index";
import store from "@/store";

// Bulk
import BulkDashboard from "@/bulk/dashboard";
import BulkMessages from "@/bulk/messages";
import BulkMessagesDetails from "@/bulk/message-details";
import BulkSenderIDs from "@/bulk/sender-ids";
import BulkTemplates from "@/bulk/templates";
import BulkReports from "@/bulk/reports";
import BulkCreate from "@/components/create-message";

// Inbox
import Inbox from "@/inbox/messages";
import InboxMessageDetails from "@/inbox/message-details";
import InboxKeywords from "@/inbox/keywords";
import InboxKeywordDetails from "@/inbox/keyword-details";
import Shortcodes from "@/inbox/shortcodes";

// Contacts
import Contacts from "@/contacts/list";
import ContactsBuilder from "@/contacts/builder";
import ContactsBlacklist from "@/contacts/blacklist";
// eslint-disable-next-line no-unused-vars
import ContactsListDetails from "@/contacts/list-details";

// Payments
import Payments from "@/payments/dashboard";
import PaymentsTransactions from "@/payments/transactions";
import PaymentsBulk from "@/payments/bulk-payments";
import PaymentsCreate from "@/payments/create-bulk-payment";
import PaymentsBulkDetails from "@/payments/bulk-payments-details";

// Surveys
import SurveyCampaigns from "@/surveys/surveys";
import SurveyReports from "@/surveys/reports";
import CreateSurvey from "@/surveys/create";
import SurveyView from "@/surveys/survey-view";
import SurveyQuestionnaires from "@/surveys/questionnaires"
import SurveyResponsesData  from "@/surveys/survey-responses-data";

// API
import API from "@/api/dashboard";

// Account
import AccountSummary from "@/account/summary";
import AccountUsers from "@/account/users";
import AccountTransactions from "@/account/transactions";
import AccountInvoices from "@/account/invoices";

// Admin & Agents
import AgentDashboard from "@/agent/dashboard";
import AdminDashboard from "@/admin/dashboard";


Vue.use(Router)

const router =  new Router({
    mode: "history",
    routes: [
        { path: '/', name: 'home', component: Home },
        { path: '/signup', name: 'signup', component: Signup },
        { path: '/login', name: 'login', component: Login },
        { path: '/verify', name: 'verify-account', component: VerifyAccount },
        { path: '/forgot', name: 'forgot', component: ForgotPassword },
        { path: '/set-password', name: 'set-password', component: SetPassword },
        { path: "*", component: PageNotFound },

        {path: '/bulk', component: AppIndex, children: [
            { path: '', name: 'bulk-dashboard', component: BulkDashboard, meta: { name: "Bulk SMS"} },
            { path: 'messages', name: 'bulk-messages', component: BulkMessages, meta: { name: "Messages"} },
            { path: 'messages/:id', name: 'bulk-messages-details', component: BulkMessagesDetails, meta: { name: "Message"} },
            { path: 'senderids', name: 'bulk-senderids', component: BulkSenderIDs, meta: { name: "Sender IDs"} },
            { path: 'templates', name: 'bulk-templates', component: BulkTemplates, meta: { name: "Templates"} },
            { path: 'reports', name: 'bulk-reports', component: BulkReports, meta: { name: "Reports"} },
            { path: 'create', name: 'bulk-create', component: BulkCreate, meta: { name: "Send SMS"} },
        ]},
        {path: '/inbox', component: AppIndex, children: [
            { path: '', name: 'inbox', component: Inbox, meta: { name: "Inbox"} },
            { path: 'keyword', name: 'inbox-keywords', component: InboxKeywords, meta: { name: "Inbox Keywords"} },
            { path: '', component: Inbox, children: [
                { path: ':id', name: 'inbox-message-details', component: InboxMessageDetails, meta: { name: "Inbox"} },
            ] },
            { path: 'keyword', component: InboxKeywords, children: [
                { path: ':id', name: 'inbox-keywords-details', component: InboxKeywordDetails, meta: { name: "Inbox Keywords"} },
            ] },
        ]},
        { path: '/shortcodes',  component: AppIndex, children: [
            { path: '', name: 'shortcodes', component: Shortcodes, meta: { name: "Shortcodes"} },
        ]},
        
        {path: '/contacts', component: AppIndex, children: [
            { path: '', name: 'contacts', component: Contacts, meta: { name: "Contacts"} },
            { path: 'builder', name: 'contacts-builder', component: ContactsBuilder, meta: { name: "Database Builder"} },
            { path: 'blacklist', name: 'contacts-blacklist', component: ContactsBlacklist, meta: { name: "Blacklist"} },
            { path: 'details/:id', name: 'ListDetails', component: ContactsListDetails, meta: { name: "Contact"} },
        ]},
        {path: '/payments', component: AppIndex, children: [
            { path: '', name: 'payments', component: Payments, meta: { name: "Payments"} },
            { path: 'transactions', name: 'payments-transactions', component: PaymentsTransactions, meta: { name: "Payments"} },
            { path: 'transactions/:id', name: 'payments-transactions-details', component: PaymentsTransactions, meta: { name: "Payment"} },
            { path: 'bulk', name: 'payments-bulk', component: PaymentsBulk, meta: { name: "Bulk Payments"} },
            { path: 'create', name: 'create-payments-bulk', component: PaymentsCreate, meta: { name: "Create Bulk Payment"} },
            { path: 'details', name: 'bulk-payments-details', component: PaymentsBulkDetails, meta: { name: "Bulk Payment Details"} },
        ]},
        {path: '/surveys', component: AppIndex, children: [
            { path: '', name: 'surveys', component: SurveyCampaigns, meta: { name: "Surveys"} },
            { path: ':id', name: 'survey-view', component: SurveyView, meta: { name: "Survey"} },
            { path: 'create', name: 'survey-create', component: CreateSurvey, meta: { name: "Create Survey"} },
            { path: 'create/:id', name: 'survey-create-new', component: CreateSurvey, meta: { name: "Create Survey"} },
            { path: 'questionnaires', name: 'surveys-questionnaires', component: SurveyQuestionnaires, meta: { name: "Questionnaires"} },
            { path: 'reports', name: 'surveys-reports', component: SurveyReports, meta: { name: "Survey Reports"} },
        ]},

        {path: '/api', component: AppIndex, children: [
            { path: '', name: 'api', component: API, meta: { name: "API"} },
        ]},
        {path: '/account', component: AppIndex, children: [
            { path: '', name: 'account-summary', component: AccountSummary, meta: { name: "Account"}},
            { path: 'users', name: 'account-users', component: AccountUsers, meta: { name: "Account"}},
            { path: 'transactions', name: 'account-transactions', component: AccountTransactions, meta: { name: "Account"}},
            { path: 'invoices', name: 'account-invoices', component: AccountInvoices, meta: { name: "Invoices"}},
        ]},

        {path: '/agent', component: AppIndex, children: [
            { path: '', name: 'agent-dashboard', component: AgentDashboard, meta: { name: "Agent"} },
        ]},
        {path: '/admin', component: AppIndex, children: [
            { path: '', name: 'admin-dashboard', component: AdminDashboard, meta: { name: "Admin"} },
        ]},
    ]
});
router.beforeEach((to, from, next) => {
    //document.title = to.meta.title + ' | ' + to.meta.mainTitle;
    var isCalled = $cookies.get("iscalled");
    var token=$cookies.get("key");
    var username = $cookies.get("username");
    
    if(!isCalled || token){
        
        $cookies.set("iscalled",true,"60s");
        if(store.state.user===null){
            
            if($cookies.isKey("key")){
                
               //console.log("get user data using this token");
                var token = $cookies.get("key");
                //get user data using this token
                $.post({
                    url: store.state.rootURLUser + "users/profile",
                    type: "POST",
                    data: JSON.stringify({
                      apiKey: token
                    }),
                    success: function(response, status, jQxhr) {
                        store.commit("setuser",response.data);
                        next(true);
                    },
                    error: function(jQxhr, status, error) {
                        $cookies.remove("key");
                        next({path: "/login", replace: true});
                    }
                  });

            } else {
                

              //  console.log("user not null  "+from.path+" to path "+to.path);
                if(to.path.indexOf("bulk") !== -1 || to.path.includes("survey") ){
                    //console.log("user not null  "+from.path+" to path "+to.path);
                    next({path: "/", replace: false});
                }
                else if(to.path == "/subscription/" || to.path=="/inbox" || to.path=="/api/"
                    || to.path == "/subscription" || to.path=="/inbox/" || to.path=="/api"){
                    next({path: "/", replace: false});
                }
                else if((from.path=="/" && to.path=="/login") || to.path=="/login" ){
                    //console.log("user not null  "+from.path+" to path "+to.path);
                    next(true);
                }
                else if((from.path=="/" || from.path=="/login") && (to.path=="/register" || to.path=="/forgotpassword") ){
                    //console.log("user not null status >0 "+from.path+" to path "+to.path);
                    next(true);
                }
                else if(to.path=="/"){
                    //console.log("user not null status >0 "+from.path+" to path "+to.path);
                    next(true);
                }
                else{
                  //  console.log("else "+from.path+" to path "+to.path);
                    next(true);
                    //next({path: "/", replace: false});
                }

            }
        } else{
            
           // console.log("outside else where");
            if(store.state.user.status<=0){
               // console.log("user not null statu<=0 "+from.path+" to path "+to.path);

                next({path:"/verify",replace:true});
            }
            else if($cookies.isKey("key") == false){

                next({path: "/", replace: false});
                
            }
            else{
                if((from.path=="/" && to.path=="/login") || to.path=="/login" ){
                   // console.log("My token exist");
                    next({path:"/bulk",replace:true});
                    
                }
                else{
                    next(true);
                }
            }
        }
    }
    else if(!username){
        
        if($cookies.isKey("key")){
            //var token=$cookies.get("token");
            $cookies.remove("key");
            
        }

        if(to.path.includes("bulk") || to.path.includes("survey")){
          //  console.log("user not null  "+from.path+" to path "+to.path);
            next({path: "/", replace: false});
        }
        else if(to.path == "/subscription/" || to.path=="/inbox" || to.path=="/api/" || to.path == "/payments/" || to.path == "/payments/transactions"
            || to.path == "/subscription" || to.path=="/inbox/" || to.path=="/inbox/keyword" || to.path=="/contacts/" || to.path=="/shortcodes/" || to.path=="/shortcodes"
            || to.path=="/contacts" || to.path=="/contacts/blacklist" || to.path=="/contacts/builder" || to.path=="/agent/" || to.path=="/agent"
            || to.path=="/account/users" || to.path=="/account/invoices" || to.path=="/account/transactions" || to.path=="/api" 
            ||  to.path == "/account/" || to.path=="/account/home" || to.path=="/verify" || to.path=="/set-password"){
                
            next({path: "/", replace: false});
        }

       else if((from.path=="/" && to.path=="/login") || to.path=="/login" ){
            //console.log("user not null  "+from.path+" to path "+to.path);
            next(true);
        }

        else if((from.path=="/" || from.path=="/login") && (to.path=="/register" || to.path=="/forgotpassword") ){
            //console.log("user not null status >0 "+from.path+" to path "+to.path);
            next(true);
        }
        else if(to.path=="/"){
            //console.log("user not null status >0 "+from.path+" to path "+to.path);
            next(true);
        }
        // else if(to.path=="/verify"){
        //     next({path: "/login", replace: false});
        // }
        else{
           // console.log("else "+from.path+" to path "+to.path);
            //next(true);
            next(true);
        }

    }
    else {
       //console.log("outside else");
        //console.log("user not null  "+from.path+" to path "+to.path);

        if($cookies.isKey("key")){
            //var token=$cookies.get("token");
            $cookies.remove("key");
            
        }

        if(to.path.includes("bulk") || to.path.includes("survey")){
          //  console.log("user not null  "+from.path+" to path "+to.path);
            next({path: "/", replace: false});
        }
        else if(to.path == "/subscription/" || to.path=="/inbox" || to.path=="/api/" || to.path == "/payments/" || to.path == "/payments/transactions"
            || to.path == "/subscription" || to.path=="/inbox/" ||  to.path=="/inbox/keyword" || to.path=="/contacts/" || to.path=="/contacts" 
            || to.path=="/account/users" || to.path=="/account/invoices" || to.path=="/account/transactions" || to.path=="/api"
            ||  to.path == "/account/" || to.path=="/account/home"){
                
            next({path: "/", replace: false});
        }

       else if((from.path=="/" && to.path=="/login") || to.path=="/login" ){
            //console.log("user not null  "+from.path+" to path "+to.path);
            next(true);
        }

        else if((from.path=="/" || from.path=="/login") && (to.path=="/register" || to.path=="/forgotpassword" || to.path=="/verify" ) ){
            //console.log("user not null status >0 "+from.path+" to path "+to.path);
            next(true);
        }
        else if(to.path=="/"){
            //console.log("user not null status >0 "+from.path+" to path "+to.path);
            next(true);
        }
        // else if(to.path=="/verify"){
        //     next({path: "/login", replace: false});
        // }
        else{
           // console.log("else "+from.path+" to path "+to.path);
            //next(true);
            next(true);
        }
    }
});
export default router;
